export const ObjectToFormData = (args) => {
  const body = new FormData();
  Object.keys(args).forEach((key) => {
    body.append(key, args[key]);
  });
  return body;
};
